import { FormattedEvent } from '@eventbrite/event-renderer';
import React from 'react';
import {
    GA_VIEW_EVENT_ACTION,
    GA_VIEW_MORE_ACTION,
} from '../../constants/analytics';
import { SearchEventCardStyleSwitcher } from '../../containers/SearchEventCardStyleSwitcher';
import { FeatureFlags } from '../../types/index';
import { SeeMoreButton } from '../SeeMoreButton';

//TODO: Rename SearchEventCardStyleSwitcher but leave as a layer to render various experiment varieties
export const ListEventCardGroup = ({
    cards,
    linkUrl,
    title,
    isAuthenticated,
    onTrackClick,
    onTrackClickInternal,
    trackGAEventOnPageUnload,
    affCode,
    locale,
}: {
    cards: any;
    linkUrl: string;
    title: string;
    isAuthenticated: boolean;
    onTrackClick: Function;
    onTrackClickInternal?: Function;
    trackGAEvent?: Function;
    featureFlags: FeatureFlags;
    trackGAEventOnPageUnload: Function;
    affCode?: string;
    locale?: string;
}) => {
    const handleClick = (id: string, index: number) => {
        onTrackClick?.({ id }, GA_VIEW_EVENT_ACTION);
        onTrackClickInternal?.(index);
    };

    return (
        <div>
            <ul className="search-main-content__events-list">
                {cards.map(
                    ({ id, ...cardProps }: { id: string }, index: number) => (
                        <li key={id}>
                            <SearchEventCardStyleSwitcher
                                {...cardProps}
                                onClick={() => handleClick(id, index)}
                                isAuthenticated={isAuthenticated}
                                affCode={affCode}
                                event={{ ...cardProps, id } as FormattedEvent}
                                locale={locale || 'en_US'}
                            />
                        </li>
                    ),
                )}
            </ul>
            <div className="eds-show-down-sn eds-align--center eds-l-pad-top-6">
                <SeeMoreButton
                    linkUrl={linkUrl}
                    trackClick={trackGAEventOnPageUnload}
                    title={title}
                    gaAction={GA_VIEW_MORE_ACTION}
                    size="block"
                />
            </div>
        </div>
    );
};

export default ListEventCardGroup;
